import { create } from "zustand";
import { AddToCartInput, AddToCartResponse } from "../types"; // Assurez-vous que les types sont correctement définis
import { toast } from "react-toastify";
import { URL } from "../../lib/apis";

interface CartState {
  addToCart: (input: AddToCartInput) => Promise<void>;
  newCartItem: AddToCartResponse | null;
  loading: boolean;
}

const useAddCart = create<CartState>((set) => ({
  newCartItem: null, // Initialise à null avant d'ajouter un produit
  loading: false,

  addToCart: async (input: AddToCartInput) => {
    const token = localStorage.getItem("token");
    if (!token) {
      toast.error("User is not authenticated.", {
        position: "bottom-right", // Change this to the desired position
      });
      console.error("User is not authenticated");
      return;
    }

    set({ loading: true });

    try {
      const response = await fetch(
        `${URL}/cart/add`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(input), // Envoie les données d'ajout au panier
        }
      );

      if (!response.ok) {
        throw new Error(`Failed to add product to cart: ${response.statusText}`);
      }

      const data: AddToCartResponse = await response.json();
      set({ newCartItem: data, loading: false }); // Met à jour avec la réponse
      toast.success("Produit ajouté au panier avec succès !", {
        position: "bottom-right", // Change this to the desired position
      });
    } catch (error) {
      if (error instanceof Error) {
        console.error("Error adding product to cart:", error.message);
      } else {
        console.error("Unknown error occurred");
      }
      set({ loading: false });
    }
  },
}));

export default useAddCart;
